<template>
  <div class="banner-bg">
    <div class="container">
      <div class="col-lg-12 d-flex justify-content-center pb-3 mb-lg-2 m-top" @click="redirectBanner()">
        <img
          :src="imageSrc"
          :alt="imageAlt"
          :width="isMobile() ? 369 : 1254"
          :height="isMobile() ? 45 : 124"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import imagePt from 'assets/img/Banner-BR-desktop-marcela-e-mel.webp'
  import imageEn from 'assets/img/Banner-EN-desktop-marcela-e-mel.webp'
  import imagePtMobile from 'assets/img/Banner-BR-mobile-marcela-e-mel.webp'
  import imageEnMobile from 'assets/img/Banner-EN-mobile-marcela-e-mel.webp'
  import { isMobile } from '@/shared/utils/mobile'

const route = useRoute()

  const imageAlt = computed(() => {
    if (route.params.language === 'pt-br') return 'Ensaio Grátis'
    return 'Free Trial'
  })

  const imageSrc = computed(() => {
    if (route.params.language === 'pt-br') return isMobile() ? imagePtMobile : imagePt
    return isMobile() ? imageEnMobile : imageEn
  })

  // Pagina propria de captura (antes era o formulario do Campaigner, em outra
  // aba). O idioma vai na rota e escolhe o funil — ver previas-gratis.vue.
  function redirectBanner() {
    navigateTo({ name: 'language-previas-gratis', params: { language: route.params.language } })
  }
</script>
<script lang="ts"></script>
<style scoped lang="css">
  img {
    width: 1254px;
    height: 124px;
    cursor: pointer;
  }

  /* até 1199px (inclui faixa tablet/iPad) a imagem é fluida; acima disso volta
     ao tamanho fixo do desktop. Antes parava em 992px e estourava em 993–1199px. */
  @media screen and (max-width: 1199px) {
    img {
      width: 95%;
      cursor: pointer;
      object-fit: cover;
      height: auto;
    }
    .m-top {
      margin-top: 50px;
    }
  }
  @media screen and (max-width: 769px) {
    .banner-bg {
      background: linear-gradient(to bottom, #000 0 50%, #F0F0F0 50%);
    }
    .banner-bg .col-lg-12 {
      padding-bottom: 0;
    }
    .m-top {
      margin-top: 0px;
    }
  }
</style>
